import type { ComponentChildren } from 'preact';
import { Icon } from './Icon';

/** A collapsible card. */
export function Section({ title, count, open = true, actions, children }: { title: ComponentChildren; count?: number | string; open?: boolean; actions?: ComponentChildren; children: ComponentChildren }) {
  return (
    <details class="section" open={open}>
      <summary>
        <Icon name="chevronRight" class="chev" size={16} />
        <span>{title}</span>
        {count !== undefined && <span class="count">({count})</span>}
        {actions && (
          <span class="right row" onClick={(e) => e.preventDefault()}>
            {actions}
          </span>
        )}
      </summary>
      <div class="card-body">{children}</div>
    </details>
  );
}

export function Card({ title, actions, children, foot, class: cls }: { title?: ComponentChildren; actions?: ComponentChildren; children: ComponentChildren; foot?: ComponentChildren; class?: string }) {
  return (
    <section class={`card ${cls ?? ''}`}>
      {(title || actions) && (
        <div class="card-head">
          {title && <h2>{title}</h2>}
          {actions && <div class="row">{actions}</div>}
        </div>
      )}
      <div class="card-body">{children}</div>
      {foot && <div class="card-foot">{foot}</div>}
    </section>
  );
}
